import { Form, Row } from "antd";
import { AdvancedForm } from "../form/advanced-form";
import { useForm } from "antd/es/form/Form";
import FormItem from "../form/form-item";
import { useCallback, useMemo } from "react";
import { useCreatePriceOverwriteMutation, useDeletePriceOverwriteMutation, useGetPriceOverwritesQuery, useUpdatePriceOverwriteMutation } from "../../../api/plamo-api";
import { showSuccessMessage } from "../util/with-save-notification";

const modesOptions = [
  {
    label: 'Pauschale',
    value: 'fixed'
  },
  {
    label: 'Anfahrtzeit',
    value: 'time'
  },
  {
    label: 'Strecke',
    value: 'distance'
  }
]

function Pricing({ customerId }) {
  const [form] = useForm();

  const [createPriceOverwrite] = useCreatePriceOverwriteMutation();
  const [updatePriceOverwrite] = useUpdatePriceOverwriteMutation();
  const [deletePriceOverwrite] = useDeletePriceOverwriteMutation();

  //const { data: prices } = usePri

  const supportAmountCalloutFeeMode = Form.useWatch("supportAmountCalloutFeeMode", form);
  const supportAmountCalloutFeeModeDefault = Form.useWatch("supportAmountCalloutFeeModeDefault", form);
  const absenceCareCalloutFeeMode = Form.useWatch("absenceCareCalloutFeeMode", form);
  const absenceCareCalloutFeeModeDefault = Form.useWatch("absenceCareCalloutFeeModeDefault", form);
  const shortTermCareCalloutFeeMode = Form.useWatch("shortTermCareCalloutFeeMode", form);
  const shortTermCareCalloutFeeModeDefault = Form.useWatch("shortTermCareCalloutFeeModeDefault", form);
  const conversionCalloutFeeMode = Form.useWatch("conversionCalloutFeeMode", form);
  const conversionCalloutFeeModeDefault = Form.useWatch("conversionCalloutFeeModeDefault", form);
  const privateFundedCalloutFeeMode = Form.useWatch("privateFundedCalloutFeeMode", form);
  const privateFundedCalloutFeeModeDefault = Form.useWatch("privateFundedCalloutFeeModeDefault", form);

  const filter = useMemo(() => ({ customer: { c: "EQ", v: null }}), [])
  const { data: pricesDefault } = useGetPriceOverwritesQuery({ f: JSON.stringify(filter) }) as any;

  const filterOverwrites = useMemo(() => customerId ? { "customer.id": { c: "EQ", v: customerId } } : { customer: { c: "EQ", v: null }}, [customerId])
  const { data: priceOverwrites } = useGetPriceOverwritesQuery({ f: JSON.stringify(filterOverwrites) }) as any;

  const priceOverwritesByIdent = useMemo(() => {
    const result = {}
    priceOverwrites?.items?.forEach(i => result[i.ident] = i);
    return result;
  }, [priceOverwrites?.items]);

  const values = useMemo(() => {
    const result = {} as any;
    priceOverwrites?.items?.forEach(i => result[i.ident] = i.value);
    pricesDefault?.items?.forEach(i => result[i.ident + "Default"] = i.value);
    if(result.supportAmountCalloutFeeFixed) {
      result.supportAmountCalloutFeeMode = "fixed";
    } else if(result.supportAmountCalloutFeeByDistance) {
      result.supportAmountCalloutFeeMode = "distance";
    } else if(result.supportAmountCalloutFeeByHour) {
      result.supportAmountCalloutFeeMode = "time";
    }
    if(result.supportAmountCalloutFeeFixedDefault) {
      result.supportAmountCalloutFeeModeDefault = "fixed";
    } else if(result.supportAmountCalloutFeeByDistanceDefault) {
      result.supportAmountCalloutFeeModeDefault = "distance";
    } else if(result.supportAmountCalloutFeeByHourDefault) {
      result.supportAmountCalloutFeeModeDefault = "time";
    }

    if(result.absenceCareCalloutFeeFixed) {
      result.absenceCareCalloutFeeMode = "fixed";
    } else if(result.absenceCareCalloutFeeByDistance) {
      result.absenceCareCalloutFeeMode = "distance";
    } else if(result.absenceCareCalloutFeeByHour) {
      result.absenceCareCalloutFeeMode = "time";
    }
    if(result.absenceCareCalloutFeeFixedDefault) {
      result.absenceCareCalloutFeeModeDefault = "fixed";
    } else if(result.absenceCareCalloutFeeByDistanceDefault) {
      result.absenceCareCalloutFeeModeDefault = "distance";
    } else if(result.absenceCareCalloutFeeByHourDefault) {
      result.absenceCareCalloutFeeModeDefault = "time";
    }

    if(result.shortTermCareCalloutFeeFixed) {
      result.shortTermCareCalloutFeeMode = "fixed";
    } else if(result.shortTermCareCalloutFeeByDistance) {
      result.shortTermCareCalloutFeeMode = "distance";
    } else if(result.shortTermCareCalloutFeeByHour) {
      result.shortTermCareCalloutFeeMode = "time";
    }
    if(result.shortTermCareCalloutFeeFixedDefault) {
      result.shortTermCareCalloutFeeModeDefault = "fixed";
    } else if(result.shortTermCareCalloutFeeByDistanceDefault) {
      result.shortTermCareCalloutFeeModeDefault = "distance";
    } else if(result.shortTermCareCalloutFeeByHourDefault) {
      result.shortTermCareCalloutFeeModeDefault = "time";
    }

    if(result.conversionCalloutFeeFixed) {
      result.conversionCalloutFeeMode = "fixed";
    } else if(result.conversionCalloutFeeByDistance) {
      result.conversionCalloutFeeMode = "distance";
    } else if(result.conversionCalloutFeeByHour) {
      result.conversionCalloutFeeMode = "time";
    }
    if(result.conversionCalloutFeeFixedDefault) {
      result.conversionCalloutFeeModeDefault = "fixed";
    } else if(result.conversionCalloutFeeByDistanceDefault) {
      result.conversionCalloutFeeModeDefault = "distance";
    } else if(result.conversionCalloutFeeByHourDefault) {
      result.conversionCalloutFeeModeDefault = "time";
    }

    if(result.privateFundedCalloutFeeFixed) {
      result.privateFundedCalloutFeeMode = "fixed";
    } else if(result.privateFundedCalloutFeeByDistance) {
      result.privateFundedCalloutFeeMode = "distance";
    } else if(result.privateFundedCalloutFeeByHour) {
      result.privateFundedCalloutFeeMode = "time";
    }
    if(result.privateFundedCalloutFeeFixedDefault) {
      result.privateFundedCalloutFeeModeDefault = "fixed";
    } else if(result.privateFundedCalloutFeeByDistanceDefault) {
      result.privateFundedCalloutFeeModeDefault = "distance";
    } else if(result.privateFundedCalloutFeeByHourDefault) {
      result.privateFundedCalloutFeeModeDefault = "time";
    }

    return result;
  }, [priceOverwrites?.items, pricesDefault?.items]);

  const onFinish = useCallback(async (newValues: any) => {
    
    const priceOverwritesCreate = Object.entries(newValues).filter(([k, _]) => !priceOverwritesByIdent[k]).filter(([_, v]) => v !== undefined).filter(([k, _]) => !k.endsWith("Mode")).map(([k, v]) => ({ customerId, ident: k, value: v }));
    const priceOverwritesDelete = Object.entries(priceOverwritesByIdent).filter(([k, _]) => newValues[k] === null).map(([_, v]) => v);
    const priceOverwritesUpdate = Object.entries(priceOverwritesByIdent).filter(([k, v]: [string, any]) => newValues[k] !== null && newValues[k] !== v.value).map(([k, v]: [string, any]) => ({...v, value: newValues[k]}))

    const createPromises = priceOverwritesCreate.map(createPriceOverwrite);
    const deletePromises = priceOverwritesDelete.map(deletePriceOverwrite);
    const updatePromises = priceOverwritesUpdate.map(updatePriceOverwrite);

    await Promise.all([...createPromises, ...deletePromises, ...updatePromises])

    showSuccessMessage();
  }, [priceOverwritesByIdent, createPriceOverwrite, updatePriceOverwrite, deletePriceOverwrite, customerId]);

  return <div  style={{ height: "100%", overflow: "scroll", display: 'flex', flexDirection: 'column' }}>
      <AdvancedForm form={form} name="customer" onFinish={onFinish} isLoading={false} originalValues={values} initialEditing={false}>
      <Row><h3>Entlastungsbetrag</h3></Row>
      { customerId && <Row gutter={24}>
        <FormItem fieldName="supportAmountHourlyRateDefault" label="Stundenpreis standard" type="currency" readOnly />
        <FormItem fieldName="supportAmountCalloutFeeModeDefault" label="Verrechnung Anfahrt" type="enum" typeData={{ options: modesOptions }} readOnly />
        { supportAmountCalloutFeeModeDefault === 'fixed' && <FormItem fieldName="supportAmountCalloutFeeFixedDefault" label="Fahrkosten pauschal" type="currency" /> }
        { supportAmountCalloutFeeModeDefault === 'time' && <FormItem fieldName="supportAmountCalloutFeeByHourDefault" label="Fahrkosten pro Stunde" type="currency" /> }
        { supportAmountCalloutFeeModeDefault === 'distance' && <FormItem fieldName="supportAmountCalloutFeeByDistanceDefault" label="Fahrkosten pro KM" type="currency" /> }
        { !['fixed', 'time', 'distance'].includes(supportAmountCalloutFeeModeDefault) && <FormItem fieldName="" label="" type="empty" /> }
        <FormItem fieldName="supportAmountHourlyRateCalcDefault" label="Stundenpreis kalk." type="currency" readOnly />
      </Row> }
      <Row gutter={24}>
        <FormItem fieldName="supportAmountHourlyRate" label="Stundenpreis indiv." type="currency" />
        <FormItem fieldName="supportAmountCalloutFeeMode" label="Verrechnung Anfahrt" type="enum" typeData={{ options: modesOptions }} />
        { supportAmountCalloutFeeMode === 'fixed' && <FormItem fieldName="supportAmountCalloutFeeFixed" label="Fahrkosten pauschal" type="currency" /> }
        { supportAmountCalloutFeeMode === 'time' && <FormItem fieldName="supportAmountCalloutFeeByHour" label="Fahrkosten pro Stunde" type="currency" /> }
        { supportAmountCalloutFeeMode === 'distance' && <FormItem fieldName="supportAmountCalloutFeeByDistance" label="Fahrkosten pro KM" type="currency" /> }
        { !['fixed', 'time', 'distance'].includes(supportAmountCalloutFeeMode) && <FormItem fieldName="" label="" type="empty" /> }
        <FormItem fieldName="supportAmountHourlyRateCalc" label="Stundenpreis kalk." type="currency" />
      </Row>
      <Row><h3>Verhinderungspflege</h3></Row>
      { customerId && <Row gutter={24}>
        <FormItem fieldName="absenceCareHourlyRateDefault" label="Stundenpreis standard" type="currency" readOnly />
        <FormItem fieldName="absenceCareCalloutFeeModeDefault" label="Verrechnung Anfahrt" type="enum" typeData={{ options: modesOptions }} readOnly />
        { absenceCareCalloutFeeModeDefault === 'fixed' && <FormItem fieldName="absenceCareCalloutFeeFixedDefault" label="Fahrkosten pauschal" type="currency" /> }
        { absenceCareCalloutFeeModeDefault === 'time' && <FormItem fieldName="absenceCareCalloutFeeByHourDefault" label="Fahrkosten pro Stunde" type="currency" /> }
        { absenceCareCalloutFeeModeDefault === 'distance' && <FormItem fieldName="absenceCareCalloutFeeByDistanceDefault" label="Fahrkosten pro KM" type="currency" /> }
        { !['fixed', 'time', 'distance'].includes(absenceCareCalloutFeeModeDefault) && <FormItem fieldName="" label="" type="empty" /> }
        <FormItem fieldName="absenceCareHourlyRateCalcDefault" label="Stundenpreis kalk." type="currency" readOnly />
      </Row> }
      <Row gutter={24}>
        <FormItem fieldName="absenceCareHourlyRate" label="Stundenpreis" type="currency" />
        <FormItem fieldName="absenceCareCalloutFeeMode" label="Verrechnung Anfahrt" type="enum" typeData={{ options: modesOptions }} />
        { absenceCareCalloutFeeMode === 'fixed' && <FormItem fieldName="absenceCareCalloutFeeFixed" label="Fahrkosten pauschal" type="currency" /> }
        { absenceCareCalloutFeeMode === 'time' && <FormItem fieldName="absenceCareCalloutFeeByHour" label="Fahrkosten pro Stunde" type="currency" /> }
        { absenceCareCalloutFeeMode === 'distance' && <FormItem fieldName="absenceCareCalloutFeeByDistance" label="Fahrkosten pro KM" type="currency" /> }
        { !['fixed', 'time', 'distance'].includes(absenceCareCalloutFeeMode) && <FormItem fieldName="" label="" type="empty" /> }
        <FormItem fieldName="absenceCareHourlyRateCalc" label="Stundenpreis kalk." type="currency" />
      </Row>
      <Row><h3>Kurzzeitpflege</h3></Row>
      { customerId && <Row gutter={24}>
        <FormItem fieldName="shortTermCareHourlyRateDefault" label="Stundenpreis standard" type="currency" readOnly />
        <FormItem fieldName="shortTermCareCalloutFeeModeDefault" label="Verrechnung Anfahrt" type="enum" typeData={{ options: modesOptions }} readOnly />
        { shortTermCareCalloutFeeModeDefault === 'fixed' && <FormItem fieldName="shortTermCareCalloutFeeFixedDefault" label="Fahrkosten pauschal" type="currency" readOnly /> }
        { shortTermCareCalloutFeeModeDefault === 'time' && <FormItem fieldName="shortTermCareCalloutFeeByHourDefault" label="Fahrkosten pro Stunde" type="currency" readOnly /> }
        { shortTermCareCalloutFeeModeDefault === 'distance' && <FormItem fieldName="shortTermCareCalloutFeeByDistanceDefault" label="Fahrkosten pro KM" type="currency" readOnly /> }
        { !['fixed', 'time', 'distance'].includes(shortTermCareCalloutFeeModeDefault) && <FormItem fieldName="" label="" type="empty" /> }
        <FormItem fieldName="shortTermCareHourlyRateCalcDefault" label="Stundenpreis kalk." type="currency" readOnly />
      </Row> }
      <Row gutter={24}>
        <FormItem fieldName="shortTermCareHourlyRate" label="Stundenpreis indiv." type="currency" />
        <FormItem fieldName="shortTermCareCalloutFeeMode" label="Verrechnung Anfahrt" type="enum" typeData={{ options: modesOptions }} />
        { shortTermCareCalloutFeeMode === 'fixed' && <FormItem fieldName="shortTermCareCalloutFeeFixed" label="Fahrkosten pauschal" type="currency" /> }
        { shortTermCareCalloutFeeMode === 'time' && <FormItem fieldName="shortTermCareCalloutFeeByHour" label="Fahrkosten pro Stunde" type="currency" /> }
        { shortTermCareCalloutFeeMode === 'distance' && <FormItem fieldName="shortTermCareCalloutFeeByDistance" label="Fahrkosten pro KM" type="currency" /> }
        { !['fixed', 'time', 'distance'].includes(shortTermCareCalloutFeeMode) && <FormItem fieldName="" label="" type="empty" /> }
        <FormItem fieldName="shortTermCareHourlyRateCalc" label="Stundenpreis kalk." type="currency" />
      </Row>
      <Row><h3>Umwandlung</h3></Row>
      { customerId && <Row gutter={24}>
        <FormItem fieldName="conversionHourlyRateDefault" label="Stundenpreis standard" type="currency" readOnly />
        <FormItem fieldName="conversionCalloutFeeModeDefault" label="Verrechnung Anfahrt" type="enum" typeData={{ options: modesOptions }} readOnly />
        { conversionCalloutFeeModeDefault === 'fixed' && <FormItem fieldName="conversionCalloutFeeFixedDefault" label="Fahrkosten pauschal" type="currency" readOnly /> }
        { conversionCalloutFeeModeDefault === 'time' && <FormItem fieldName="conversionCalloutFeeByHourDefault" label="Fahrkosten pro Stunde" type="currency" readOnly /> }
        { conversionCalloutFeeModeDefault === 'distance' && <FormItem fieldName="conversionCalloutFeeByDistanceDefault" label="Fahrkosten pro KM" type="currency" readOnly /> }
        { !['fixed', 'time', 'distance'].includes(conversionCalloutFeeModeDefault) && <FormItem fieldName="" label="" type="empty" /> }
        <FormItem fieldName="conversionHourlyRateCalcDefault" label="Stundenpreis kalk." type="currency" readOnly />
      </Row> }
      <Row gutter={24}>
        <FormItem fieldName="conversionHourlyRate" label="Stundenpreis indiv." type="currency" />
        <FormItem fieldName="conversionCalloutFeeMode" label="Verrechnung Anfahrt" type="enum" typeData={{ options: modesOptions }} />
        { conversionCalloutFeeMode === 'fixed' && <FormItem fieldName="conversionCalloutFeeFixed" label="Fahrkosten pauschal" type="currency" /> }
        { conversionCalloutFeeMode === 'time' && <FormItem fieldName="conversionCalloutFeeByHour" label="Fahrkosten pro Stunde" type="currency" /> }
        { conversionCalloutFeeMode === 'distance' && <FormItem fieldName="conversionCalloutFeeByDistance" label="Fahrkosten pro KM" type="currency" /> }
        { !['fixed', 'time', 'distance'].includes(conversionCalloutFeeMode) && <FormItem fieldName="" label="" type="empty" /> }
        <FormItem fieldName="conversionHourlyRateCalc" label="Stundenpreis kalk." type="currency" />
      </Row>
      <Row><h3>Privatzahler</h3></Row>
      { customerId && <Row gutter={24}>
        <FormItem fieldName="privateFundedHourlyRateDefault" label="Stundenpreis standard" type="currency" readOnly />
        <FormItem fieldName="privateFundedCalloutFeeModeDefault" label="Verrechnung Anfahrt" type="enum" typeData={{ options: modesOptions }} readOnly />
        { privateFundedCalloutFeeModeDefault === 'fixed' && <FormItem fieldName="privateFundedCalloutFeeFixedDefault" label="Fahrkosten pauschal" type="currency" readOnly /> }
        { privateFundedCalloutFeeModeDefault === 'time' && <FormItem fieldName="privateFundedCalloutFeeByHourDefault" label="Fahrkosten pro Stunde" type="currency" readOnly /> }
        { privateFundedCalloutFeeModeDefault === 'distance' && <FormItem fieldName="privateFundedCalloutFeeByDistanceDefault" label="Fahrkosten pro KM" type="currency" readOnly /> }
      </Row> }
      <Row gutter={24}>
        <FormItem fieldName="privateFundedHourlyRate" label="Stundenpreis indiv." type="currency" />
        <FormItem fieldName="privateFundedCalloutFeeMode" label="Verrechnung Anfahrt" type="enum" typeData={{ options: modesOptions }} />
        { privateFundedCalloutFeeMode === 'fixed' && <FormItem fieldName="privateFundedCalloutFeeFixed" label="Fahrkosten pauschal" type="currency" /> }
        { privateFundedCalloutFeeMode === 'time' && <FormItem fieldName="privateFundedCalloutFeeByHour" label="Fahrkosten pro Stunde" type="currency" /> }
        { privateFundedCalloutFeeMode === 'distance' && <FormItem fieldName="privateFundedCalloutFeeByDistance" label="Fahrkosten pro KM" type="currency" /> }
      </Row>
      <Row><h3>Beratungseinsatz</h3></Row>
      { customerId && <Row gutter={24}>
        <FormItem fieldName="counselingDefault" label="Pauschale standard" type="currency" readOnly />
      </Row>} 
      <Row gutter={24}>
        <FormItem fieldName="counseling" label="Pauschale indiv." type="currency" />
      </Row>
      </AdvancedForm>
  </div>
}

export default Pricing;